module.exports = __webpack_public_path__ + "static/media/google-play.1c6132ab.svg";